var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7988_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28239 3.44336H4.33607L5.32478 8.32755",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81352 6.59375H12.1666",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.065 15.588C8.06976 15.588 9.69495 13.9628 9.69495 11.9581C9.69495 9.95331 8.06976 8.32812 6.065 8.32812C4.06023 8.32812 2.43504 9.95331 2.43504 11.9581C2.43504 13.9628 4.06023 15.588 6.065 15.588Z",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06482 13.7398C7.04927 13.7398 7.84731 12.9417 7.84731 11.9573C7.84731 10.9729 7.04927 10.1748 6.06482 10.1748C5.08038 10.1748 4.28233 10.9729 4.28233 11.9573C4.28233 12.9417 5.08038 13.7398 6.06482 13.7398Z",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2655 15.3671C15.0799 15.3671 15.7401 14.7069 15.7401 13.8925C15.7401 13.0782 15.0799 12.418 14.2655 12.418C13.4511 12.418 12.7909 13.0782 12.7909 13.8925C12.7909 14.7069 13.4511 15.3671 14.2655 15.3671Z",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03954 6.58496H9.73446C11.4463 6.58496 11.9407 9.19796 11.9407 9.19796",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5168 13.1157L16.7174 12.418",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80498 9.47461H12.5931C13.3417 9.47461 13.9462 10.082 13.9462 10.8277L14.2626 13.8447",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83885 12.1439L6.29366 11.8105",
    stroke: "#187C85",
    strokeWidth: 0.867808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7988_444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(1.99998 2.20312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVital);
export default __webpack_public_path__ + "static/media/Vital.f68f60c94a8f4ef292a8629ffe284d6b.svg";
export { ForwardRef as ReactComponent };